import { has, keys, wrap, isArray, isObjectLike } from 'lodash-es'

const alphabeticalRE = /^\d+$/
const alphabeticalKeys = (v) => keys(v).filter(isAlphabeticalKey)
const isAlphabeticalKey = (v) => !alphabeticalRE.test(v)
const hasAlphabeticalKeys = (v) => isObjectLike(v) && (!isArray(v) || alphabeticalKeys(v).length !== 0)

import { defineHiddenGetter } from './define-getter'

const MARKER = '__attachOverridersMarker__'

const RESET = 'reset'
const OVERRIDERS = 'overriders'

export default function attachOverriders(rootObj, attachKey = OVERRIDERS) {
  const ovr = {}
  const org = {}

  defineHiddenGetter({
    obj: rootObj,
    key: attachKey,
    get: make
  })

  return rootObj

  function make() {
    const overriders = makeOverriders(rootObj)
    const resets = makeResets(rootObj)
    overriders[RESET] = resets

    return overriders
  }

  function makeOverriders(currObj) {
    const currKeys = alphabeticalKeys(currObj)
    const currOverriders = {}

    currKeys.forEach((key) => {
      const subObj = currObj[key]
      if (hasAlphabeticalKeys(subObj)) {
        defineHiddenGetter({
          obj: currOverriders,
          key,
          get: wrap(subObj, makeOverriders)
        })
      } else {
        currOverriders[key] = (v) => override(currObj, key, v)
      }
    })

    currOverriders[MARKER] = true
    return currOverriders
  }

  function makeResets(currObj) {
    const currKeys = alphabeticalKeys(currObj)
    const currResets = {}

    currKeys.forEach((key) => {
      const subObj = currObj[key]
      if (hasAlphabeticalKeys(subObj)) {
        defineHiddenGetter({
          obj: currResets,
          key,
          get: wrap(subObj, makeResets)
        })
      } else {
        currResets[key] = () => reset(currObj, key)
      }
    })

    currResets[MARKER] = true
    return currResets
  }

  function override(obj, key, val) {
    if (has(ovr, key)) {
      ovr[key] = val
      return val
    }

    ovr[key] = val
    org[key] = obj[key]

    Object.defineProperty(obj, key, {
      get: () => ovr[key],
      set: (v) => {
        org[key] = v
      },
      enumerable: true,
      configurable: true
    })

    return val
  }

  function reset(obj, key) {
    if (!has(ovr, key)) {
      return obj[key]
    }

    delete obj[key]
    obj[key] = org[key]

    delete ovr[key]
    delete org[key]

    return obj[key]
  }
}
